import '../common/base';
import Vue from '../vue/common/vue-common';
import PartnersArtistsPage from './components/partners/partners-page/PartnersArtistsPage';

new Vue(PartnersArtistsPage);
